module.exports = __webpack_public_path__ + "static/year_portrait-e9e14cae8b9e673093cd08ce0c63310e.png";